<template>
        <div style="padding-top: 1em;">
            <p>个人绑定信息维护</p>
        </div>
        <van-form>
            <van-divider :style="{ color: '#fa8a19', borderColor: '#fa8a19', padding: '0 16px' }">请核对机构信息，无需修改</van-divider>
            <van-config-provider :theme-vars="kpianawait">
                <div class="van-hairline--surround">
                    <van-cell-group inset>
                        <van-field v-model="registerData.nowHospName" readonly label="体检机构" />
                        <van-field v-model="registerData.nowHospCode" readonly label="机构编号" />
                    </van-cell-group>
                </div>
            </van-config-provider>
            <van-divider :style="{ color: '#fa8a19', borderColor: '#fa8a19', padding: '0 16px' }"></van-divider>
            <van-cell-group inset>
                <van-notice-bar scrollable left-icon="volume-o" text="请补充个人信息,信息必须是个人在该机构的预留信息！" />
                <van-field v-model="registerData.realName" required label="姓名" 
                :rules="[{ required: true, message: '请填写姓名' }]"  />
                <van-field v-model="registerData.phone" required label="手机号码" :rules="[
                    { required: true },
                    { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' },
                ]" />
                <van-field v-model="registerData.idCard" required label="身份证"
                :rules="[{ required: true, message: '请填写手机号' }]"  />
            </van-cell-group>
        </van-form>
        <div style="margin: 16px">
            <van-button round block color="linear-gradient(to right, #f67f34, #d55809)" native-type="submit" @click="getData">绑定申请</van-button>
        </div>
    <van-overlay :show="showBinging" @click="showBinging = false">
        <div class="wrapper" @click.stop>
            <div class="block">
                <van-cell-group inset>
                    <van-notice-bar wrapable :scrollable="false" text="提交申请成功" left-icon="info-o" />
                    <p class="textIndentation"><van-notice-bar wrapable :scrollable="false" color="#1989fa"
                            background="#ffffff" text="信息提交完成，我们需要【1-3个工作日】进行审核！" /></p>
                    <van-button type="warning" block plain hairline to="about">
                        返回项目介绍
                    </van-button>
                </van-cell-group>
            </div>
        </div>
    </van-overlay>
</template>
 
<script>
import { ref, toRefs, reactive, onMounted } from 'vue';
import { postHospAndMobile, getPersonInit } from '../../api/register'
import { useRouter } from 'vue-router';
import { postUserLog } from "../../api/userlog";
export default {
    setup() {
        const router = useRouter();
        const ulog = reactive({
            UserLog: {
                 path: "",
            },
        });
        const showBinging = ref(false);
        const kpianawait = reactive({
            cellGroupBackground: '#F1F1F1',
        });
        const state = reactive({
            registerData: {
                hospitalName: '',
                hospitalCode: '',
                realName: '',
                nowHospName: '',
                nowHospCode: '',
                phone: '',
                idCard: '',
            }
        })
        const hosp = reactive({
            HospInfo: {
                hospId: '',
            }
        })

        const getData = () => {
            console.log(state.registerData);
            postHospAndMobile(state.registerData).then((res) => {
                console.log(res.data.code)
                if (res.data.code == 0) {
                    console.log('绑定成功');
                    showBinging.value = true;
                } else {
                    console.log('绑定失败，失败原因:' + res.data.message);
                }
            })
        }
        onMounted(() => {
            ulog.UserLog.path = router.currentRoute.value.fullPath;
            console.log("当前页面路径==" + ulog.UserLog.path);
            postUserLog(ulog.UserLog).then(() => {});
            console.log('页面打开')
           /* var url = window.location.href;             //获取当前url
            var cs = url.split('?')[1];                //获取?之后的参数字符串
            var cs_arr = cs.split('&');                    //参数字符串分割为数组
            var cs_temp = {};
            for (var i = 0; i < cs_arr.length; i++) {         //遍历数组，拿到json对象
                cs_temp[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
            }
            console.log(cs_temp);
            hosp.HospInfo = cs_temp;
            console.log(hosp.HospInfo);*/
            getPersonInit().then((res2) => {
                state.registerData = res2.data.data;
                console.log(state.registerData);
            })
        })
        return {
            hosp,
            kpianawait,
            ...toRefs(state),
            getData,
            showBinging,

        }
    },
};
</script>
 
<style>

.textIndentation {
    font-size: 12px;
    text-align: left;
    margin-top: 10px;
}

.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.block {
    width: 500px;
    height: 400px;
}
</style>